<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/LeaveRequest.svg" class="h-20px w-20px rounded mr-2" />{{'TeamTracking'|localize}}
        </h5>
        <div *ngIf="primengTableHelper?.records?.length"  class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">
        <div *ngIf="!loading && !primengTableHelper?.records?.length">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/team-detail-empty.png" class="h-200px w-150px ml-13" />
                    <h6 class="text-muted text-center mt-5">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>

        <div class="overflow">

            <!--Updated team details code for ptable-->
            <div class="px-4 flex-grow-1 d-flex flex-column">
                <p-table *ngIf="loading"
                         [rows]="5" [paginator]="false"
                         [value]="[1,2,3,4,5]">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="text-left font-weight-bold" style="width: 19%;">{{'UserName'|localize}}</th>
                            <th class="text-left font-weight-bold" style="width: 13%;">{{'DeviceDetails'|localize}}</th>
                            <th class="text-left font-weight-bold" style="width: 11%;">{{'Task'|localize}}</th>
                            <th class="text-left font-weight-bold" style="width: 11%;">
                                {{'Arriveat'|localize}}
                                <!-- pSortableColumn="Check-in" -->
                                <!-- <p-sortIcon field="Check-in"></p-sortIcon> -->
                            </th>
                            <th class="text-left font-weight-bold" style="width: 9%;">
                                {{'LeftAt'|localize}}
                                <!-- pSortableColumn="Check out" -->
                                <!-- <p-sortIcon field="Check out"></p-sortIcon> -->
                            </th>
                            <th class="text-left font-weight-bold" style="width: 11%;">
                                {{'AtWork'|localize}}
                                <!-- pSortableColumn="Spent Time" -->
                                <!-- <p-sortIcon field="Spent Time"></p-sortIcon> -->
                            </th>
                            <th class="text-left font-weight-bold" style="width: 15%;">{{'CurrentlyUsing'|localize}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <div class="d-flex">
                                    <div class="d-flex align-items-center">
                                        <ngx-shimmer-loading [width]="'45px'" [height]="'45px'"></ngx-shimmer-loading>
                                    </div>
                                    <div class="d-flex flex-column ml-3 justify-content-center">
                                        <ngx-shimmer-loading [width]="'100px'" [height]="'8px'"></ngx-shimmer-loading>
                                        <ngx-shimmer-loading [width]="'110px'" [height]="'8px'"></ngx-shimmer-loading>
                                    </div>
                                </div>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'80px'" [height]="'12px'"></ngx-shimmer-loading>
                                <ngx-shimmer-loading [width]="'80px'" [height]="'12px'"></ngx-shimmer-loading>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'80px'" [height]="'12px'"></ngx-shimmer-loading>
                                <ngx-shimmer-loading [width]="'80px'" [height]="'12px'"></ngx-shimmer-loading>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'70px'" [height]="'15px'"></ngx-shimmer-loading>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'70px'" [height]="'15px'"></ngx-shimmer-loading>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'70px'" [height]="'15px'"></ngx-shimmer-loading>
                            </td>
                            <td class="text-left">
                                <ngx-shimmer-loading [width]="'130px'" [height]="'45px'"></ngx-shimmer-loading>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div id="dashboard-team-details">

                    <p-table #dataTable
                             *ngIf="!loading && primengTableHelper.records && primengTableHelper.records.length !== 0"
                             [rows]="5"
                             sortMode="multiple"
                             [paginator]="true"
                             [autoLayout]="true"
                             [value]="primengTableHelper.records">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-left font-weight-bold" style="width: 19%;">{{'UserName'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 13%">{{'DeviceDetails'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 11%">{{'Task'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 11% !important;">{{'Arriveat'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 9% !important;">{{'LeftAt'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 11% !important;">{{'AtWork'|localize}}</th>
                                <th class="text-left font-weight-bold" style="width: 15%;">{{'CurrentlyUsing'|localize}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-user>
                            <tr class="data-table bg-hover-gray-100" id="pointerClassOrg">
                                <td class="text-center">
                                    <div class="d-flex">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex justify-content-center align-items-end border border-light rounded w-100">
                                                <img [src]="user.profileImage ? user.profileImage : 'assets/common/images/default-profile-picture1.svg'" class="p-1 w-40px h-40px rounded"
                                                       onError="this.onerror=null; this.src='../../../../assets/common/images/default-profile-picture1.svg'" id="profimgsize">
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column ml-3 justify-content-left">
                                            <div class="fontsizedisplay intime-open-sans font-weight-bolder text-left" pTooltip="{{user.fullName }}" [tooltipDisabled]="DisableTooltip(user.fullName, 15)" tooltipPosition="bottom">
                                                {{user.fullName | titlecase | slice:0:15 }}{{ user.fullName.length > 15 ? '...' : ''}}
                                            </div>
                                            <!-- <div class="text-left font10">{{user?.roleNames?.toString().replace(',' , ', ')}} </div> -->
                                            <div class="text-left font10" pTooltip="{{ user?.roleNames?.toString().replace(',' , ', ') }}"  tooltipPosition="bottom">
                                                {{ (user?.roleNames?.toString().replace(',' , ', ')).slice(0, 10) }}{{ user?.roleNames?.toString().replace(',' , ', ').length > 10 ? '...' : '' }} | {{ user?.organizationUnitName ? user.organizationUnitName : 'N/A' }}
                                              </div>

                                            <span class="text-left font-12" [ngClass]="{'font-italic text-muted': !user?.userLiveLocation}">
                                                <img *ngIf="!user.userLiveLocation" src="../../../../assets/common/images/Activities/google-maps.svg"   onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/google-maps.svg'" class="mr-2" />
                                                <img id="locationimg" pTooltip='Work From Home' tooltipPosition="bottom" *ngIf="user.userLiveLocation && user.workingType==1" src="../../../../assets/common/images/Activities/wfh.svg" class="mr-2" />
                                                <img id="locationimg" pTooltip='Work From Remote' tooltipPosition="bottom" *ngIf="user.userLiveLocation && user.workingType==3" src="../../../../assets/common/images/Activities/wfr.svg" class="mr-2" />
                                                <img id="locationimg" pTooltip='Work From Office' tooltipPosition="bottom" *ngIf="user.userLiveLocation && user.workingType==2" src="../../../../assets/common/images/Activities/wfo.svg" class="mr-2" />
                                                {{user.userLiveLocation ? user.userLiveLocation: 'Unknown'| localize}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-left ">
                                    <ul class="devicelist mb-0">
                                        <li *ngIf="user.deviceNameWeb.includes(4)" class="font10 tooltip-bottom " data-toggle="tooltip" data-placement="bottom" data-tooltip="Android OS X 4">
                                            <img class="h-15px mr-2 " src="../../../../assets/common/images/Activities/AndroidBlue.svg" onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/AndroidBlue.svg'" />{{'Android' | localize}}

                                        </li>
                                        <li *ngIf="user.deviceNameWeb.includes(5)" class="font10 tooltip-bottom " data-toggle="tooltip" data-placement="bottom" data-tooltip="Iphone">
                                            <img class=" h-15px mr-2" src="../../../../assets/common/images/Activities/IphoneBlue.svg" onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/IphoneBlue.svg'">{{'iOS' | localize}}

                                        </li>

                                        <li *ngIf="user.deviceNameWeb.includes(2)" class="font10 tooltip-bottom " data-toggle="tooltip" data-placement="bottom" data-tooltip="Web">
                                            <img class=" h-15px mr-2" src="../../../../assets/common/images/Activities/WebAppBlue.svg" onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/WebAppBlue.svg'">{{'Web App' | localize}}

                                        </li>
                                        <li *ngIf="user.deviceNameWeb.includes(1)" class="font10 tooltip-bottom " data-toggle="tooltip" data-placement="bottom" data-tooltip="Windows 10.5(2017)">
                                            <img class=" h-15px mr-2" src="../../../../assets/common/images/Activities/WindowsBlue.svg" onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/WindowsBlue.svg'">{{'Win App' | localize}}
                                        </li>

                                        <li *ngIf="user.deviceNameWeb.includes(3)" class="font10 tooltip-bottom " data-toggle="tooltip" data-placement="bottom" data-tooltip="Mac OS X 10.3">
                                            <img class=" h-15px mr-2" src="../../../../assets/common/images/Activities/Mac AppBlue.svg" onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/Mac AppBlue.svg'">{{'Mac App' | localize}}
                                        </li>

                                        <li *ngIf="user.deviceNameWeb == 0" class="text-left">
                                            <span>---</span>
                                        </li>
                                    </ul>
                                    <div class="d-flex  mt-1 align-items-center">
                                        <img *ngIf="user && user.internetProvider" class="h-15px mr-2" src="assets/common/images/Activities/isp.svg">
                                        <!-- <small class="text-dark-75" *ngIf='user && user.internetProvider'>{{user.internetProvider | slice:0:10}}{{ user.internetProvider.length < 10 ? '' : '..' }}</small> -->
                                        <span  class="text-dark-75" *ngIf='user && user.internetProvider' pTooltip="{{ user.internetProvider }}" [tooltipDisabled]="DisableTooltip(user.internetProvider, 7)" tooltipPosition="bottom">{{user.internetProvider | slice:0:7}}{{ user.internetProvider.length < 7 ? '' : '..' }}</span>

                                        <small class="mx-2 text-dark-75" *ngIf="user && user.internetProvider && user.internetSpeed">|</small>
                                        <!-- <small class="text-dark-75" *ngIf="user && user.internetSpeed">{{user.internetSpeed }}</small> -->

                                        <span  class="text-dark-75" *ngIf='user && user.internetSpeed' pTooltip="{{ user.internetSpeed }}"  [tooltipDisabled]="DisableTooltip(user.internetSpeed, 5)" tooltipPosition="bottom">{{user.internetSpeed | slice:0:5}} {{ user.internetProvider.length < 5 ? '' : '..' }}</span>

                                    </div>
                                </td>
                                <td class="text-left">
                                    <div *ngIf=" user.taskName != null" class="d-flex flex-column">
                                        <div class="d-flex flex-column ">
                                            <span class="font-size-sm">
                                                {{user.projectName}}
                                            </span>
                                        </div>
                                        <span *ngIf="user?.checkIn">
                                            <span pTooltip="{{ user.taskName }}" [tooltipDisabled]="DisableTooltip(user.taskName, 30)" tooltipPosition="bottom">{{ (user.taskName && user.taskName.length) > 30 ? user.taskName.slice(0,30)+ '...' : user.taskName }}</span>
                                        </span>
                                        <span class="font-weight-bolder  font-size-xs text-muted font-italic" *ngIf="user?.checkIn">
                                            <span class="font-weight-bolder font-size-base mb-1 text-muted" pTooltip="{{ user.taskDescription }}" [tooltipDisabled]="DisableTooltip(user.taskDescription, 15)" tooltipPosition="bottom">{{ (user.taskDescription && user.taskDescription.length) > 15 ? user.taskDescription.slice(0,15)+ '...' : user.taskDescription }}</span>
                                        </span>
                                    </div>
                                    <div *ngIf="user.taskName == null || user.taskName === '' || !user?.checkIn">
                                        <span>---</span>
                                    </div>
                                </td>
                                <td class="text-left">
                                    <span *ngIf="user?.checkIn">
                                        {{getLocalJsDate(user.checkIn) | date: 'h:mm a'}}
                                    </span>
                                    <span class="text-center" *ngIf="!user?.checkIn">
                                        <span>---</span>
                                    </span>
                                </td>
                                <td class="text-left">
                                    <span class="text-center" *ngIf="user?.checkOut">
                                        {{getLocalJsDate(user.checkOut) | date: 'h:mm a'}}
                                    </span>
                                    <span *ngIf="!user?.checkOut">
                                        <span>---</span>
                                    </span>
                                </td>
                                <td class="text-left">
                                    <span *ngIf="user?.spendTime">
                                        {{getHoursAndMin(user.spendTime)}}
                                    </span>
                                    <span *ngIf="!user?.spendTime">
                                        <span>00{{'h'| localize}} 00{{'m'| localize}}</span>
                                    </span>
                                </td>
                                <td class="text-left">
                                    <span class="label rounded-pill h-45px label-inline border-secondary mr-2 w-180px border justify-content-start" [ngClass]="{'bg-gray-100' : user.applicationStatus === 'Neutral', 'border-secondary' : user.applicationStatus === 'Neutral',
                              'bg-white' : user.applicationStatus === null, 'borderColorinactive': user.applicationName === null, 'bg-secondary-0-45': user.applicationStatus === 'UnProductive', 'borderUnproductiveColor': user.applicationName === 'UnProductive',
                               'bg-success-o-40': user.applicationStatus === 'Productive', 'border-success': user.applicationStatus === 'Productive'}" [ngClass]="{'bg-white': user.applicationStatus ===null, 'backgroundColorinactive': user.applicationStatus !=null}">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex align-items-center ">
                                                <div class="d-flex justify-content-center align-items-end  rounded w-70">
                                                    <img *ngIf="user.icon  == null" src="../../../../assets/common/images/Activities/InactiveUserIcon.svg" class="mt-1 px-2 w-90 h-20px">
                                                    <img *ngIf="user.icon  != null || user.icon != undefined" [src]="user.icon"     onError="this.onerror=null; this.src='../../../../assets/common/images/Activities/InactiveUserIcon.svg'" class="mt-1 px-2 w-90 h-20px">
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column align-items-start ml-2">
                                                <div class="font-weight-bold text-dark-75 font-size-sm"
                                                       pTooltip="{{user.applicationName}}" tooltipPosition="bottom">
                                                    {{ user.applicationName | slice: 0:13 }}{{ user.applicationName?.length > 13 ? ".." : "" }}
                                                </div>
                                                 <div class="font-size-14" [ngClass]="{'text-dark': user.applicationStatus === 'Neutral'}">{{user.applicationStatus | localize}}</div>
                                                <div *ngIf="user.applicationStatus === null" class="font-weight-bold text-dark-75 font-size-sm">{{'NotApplicable'|localize}}</div>
                                            </div>

                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="primeng-paging-container fixed-bottom mr-1 mb-0 d-none">
                        <p-paginator [rows]="5"
                                     [alwaysShow]="false"
                                     #paginator
                                     (onPageChange)="getTeamTrackingData($event)"
                                     [totalRecords]="primengTableHelper.totalRecordsCount">
                        </p-paginator>
                    </div>

                </div>
            </div>


        </div>
    </div>
</div>



















